<template>
  <address class="review-and-complete-shipping-address">
    <h2
      class="review-and-complete-shipping-address-heading"
      v-text="$t('review-and-complete-physical-address-header')"
    />
    <v-row
      class="review-and-complete-shipping-address-address-and-form-container"
      no-gutters
    >
      <v-col class="shipping-address">
        <div>
          <span class="first-name">{{ shippingAddress.firstName }} </span>
          <span class="last-name">{{ shippingAddress.lastName }}</span>
        </div>
        <div>
          <span class="street-line-1">{{ shippingAddress.streetLine1 }}</span>
        </div>
        <div
          v-if="shippingAddress.streetLine2"
          class="street-line-2"
        >
          {{ shippingAddress.streetLine2 }}
        </div>
        <div>
          <span class="city">{{ shippingAddress.city }}, </span>
          <span class="state">{{ shippingAddress.stateOrProvince }} </span>
          <span class="zip">{{ shippingAddress.postalCode }}</span>
        </div>
        <div>
          <span class="country">{{
            countryMap[shippingAddress.countryCode]
          }}</span>
        </div>
      </v-col>
      <v-col
        cols="3"
        class="text-right"
      >
        <tc-v-btn
          id="review-and-complete-edit-address-button"
          aria-label="Edit shipping address."
          class="review-and-complete-shipping-address-edit edit"
          color="secondary"
          outlined
          @click="editButtonClicked"
          v-text="$t('review-and-complete-physical-address-edit')"
        />
      </v-col>
    </v-row>
  </address>
</template>

<script>
import { PhysicalRecipient } from '../../store/classes/recipient-physical'
import { countryMap } from '../shared/geography-service'

export default {
  name: 'ReviewAndCompleteShippingAddress',
  props: {
    shippingAddress: {
      type: PhysicalRecipient,
      required: true
    }
  },
  data () {
    return {
      countryMap
    }
  },
  methods: {
    editButtonClicked () {
      this.$emit('edit')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

.review-and-complete-shipping-address {
  font-style: normal;
}

.review-and-complete-shipping-address-heading {
  font: $font-size-lg Gotham-Medium;
  color: $tangoTextPrimary;
}

.review-and-complete-shipping-address-address-and-form-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}

.shipping-address {
  line-height: 32px;
}
</style>
